var ErrorTypes = /* @__PURE__ */ ((ErrorTypes2) => {
  ErrorTypes2["INVALID_TEXT"] = "invalid_text";
  ErrorTypes2["INVALID_ANSWER"] = "invalid_answer";
  ErrorTypes2["EMPTY_QUERY"] = "empty_query";
  ErrorTypes2["QUERY_IMAGE"] = "query_image";
  ErrorTypes2["MIN_OPTIONS"] = "min_options";
  ErrorTypes2["MAX_OPTIONS"] = "max_options";
  ErrorTypes2["MIN_MATCHES"] = "min_matches";
  ErrorTypes2["MAX_MATCHES"] = "max_matches";
  ErrorTypes2["MIN_TARGETS"] = "min_targets";
  ErrorTypes2["MAX_TARGETS"] = "max_targets";
  ErrorTypes2["MIN_QUESTIONS"] = "min_questions";
  ErrorTypes2["CUSTOM_ANSWER"] = "custom_answer";
  ErrorTypes2["EMPTY_CORRESPONDING_MATCHES_OR_OPTIONS"] = "empty_corresponding_matches_or_options";
  ErrorTypes2["EMPTY_GRAPH"] = "empty_graph";
  ErrorTypes2["INVALID_MARKS"] = "invalid_marks";
  ErrorTypes2["EMPTY_CATEGORY"] = "empty_category";
  ErrorTypes2["MIN_POINTS"] = "min_points";
  ErrorTypes2["DUPLICATE_CATEGORY"] = "duplicate_category";
  ErrorTypes2["OPTIONS_ANSWERS_SAME_LENGTH"] = "options_answers_same_length";
  return ErrorTypes2;
})(ErrorTypes || {});

export { ErrorTypes };
